import { Box, Chip, Tooltip } from '@mui/material'
import React from 'react'

function ComparaisonFilters({ filters }: { filters: { tooltip: string, title: string }[] }) {
  return (
    <Box display={'flex'} mt={2} alignItems={'center'} gap={1} flexWrap={'wrap'}>
      {filters && filters.map((filter, i) => (
        <Tooltip placement='top' title={filter.tooltip} arrow>
          <Chip key={i} sx={{ borderRadius: 1 }} label={filter.title} ></Chip>
        </Tooltip>
      ))}
    </Box>
  )
}

export default ComparaisonFilters